import React from "react";
import { useRef } from "react";
// Components
import ContentContainer from "../../../layouts/ContentContainer/ContentContainer";
import NavBar from "../../../components/NavBar/NavBar";
import Banner from "../../../layouts/Banner/Banner";
// Buttons
import ScrollToTopButton from "../../../components/Buttons/ScrollToTopButton";
// Assets
import cornerDecor from "../../../assets/imgs/growth-page/bottom-illustration.png";
import heroInnerImgRight from "../../../assets/imgs/growth-page/hero/hero-inner-img-right.png";

const Growth = () => {
   const pageRef = useRef(null);

   return (
      <div
         ref={pageRef}
         className="page page-book base-page-culture page--font-dark"
      >
         <div className="page-inner">
            <header id="page-three-top" className="header">
               <div className="background-image--growth"></div>
               <NavBar />
               <div className="hero">
                  <div className="hero__container hero__container--inner-img">
                     <div className="hero__text">
                        <p className="hero__paragraph">
                           Leaping tall buildings and looking fabulous! If I
                           could do that wearing a cape and Avado branded
                           underpants on the outside it would be amazing...
                        </p>
                     </div>
                     <div className="inner-img">
                        <img src={heroInnerImgRight} alt="" />
                     </div>
                  </div>
               </div>
            </header>

            <main>
               <ContentContainer>
                  <div className="text-container--2col">
                     <h1 className="heading heading--primary">
                        Your growth and development
                     </h1>
                     <h3 className="heading heading--tertiary">
                        Internal vacancies
                     </h3>
                     <p>
                        Where possible, we advertise roles internally to our
                        people before looking in the external market. Generally,
                        we believe that most people wouldn’t want or need to
                        change roles within six or 12 months of starting with us
                        or starting in a new role. But, where there is a need or
                        desire to do so, we will always be pragmatic. In your
                        open and honest conversations with your line manager, it
                        would be helpful if you discuss your needs and desires
                        from a career development point of view.
                     </p>
                     <br />
                     <br />
                     <br />
                     <h3 className="heading heading--tertiary">Secondments</h3>
                     <p>
                        Being a fast-moving, ambitious business means we often
                        have short- or medium-term needs for specific roles that
                        are focused on delivering certain outcomes. We may also
                        have roles to cover a planned absence of someone else.
                        These are known as secondments, and they offer a way of
                        developing your skills and giving you some really great
                        experience. A secondment means working in another role
                        for an agreed period of time. Generally, following a
                        secondment, you would return to your previous role on
                        the same terms and conditions you enjoyed beforehand.
                     </p>
                  </div>
               </ContentContainer>

               <div className="banner">
                  <div className="banner-container">
                     <Banner
                        modifier="banner-growth-secondary"
                        styleClass="content-container__container--2col"
                     >
                        <div className="text-container--1col text-container--bg-none">
                           <p className="">
                              <h3 className="">Our products</h3>
                              During your time with us you are welcome to enrol
                              on any of our products or learning experience that
                              we create – for free or a small, returnable
                              deposit. Don't hold back on exploring options you
                              may not have considered! If anything appeals to
                              you, please speak to your line manager or contact
                              your PX team for more information on enrolment.{" "}
                              <br />
                              We also offer friends and family of Avado people a
                              20% on our products; contact our B2C Sales team
                              for more information.
                           </p>
                        </div>
                        <div></div>
                     </Banner>
                  </div>
               </div>

               <ContentContainer>
                  <div className="text-container--2col">
                     <h3 className="heading heading--tertiary">
                        Objectives and key results (OKRs)
                     </h3>
                     <p>
                        Ambitious businesses need ambitious goals, and we are no
                        exception. The whole point of OKRs or personal goals is
                        for you to set out clearly what it is you will do to
                        develop and what your contribution to Avado shall be in
                        any given period. You will be asked to record your
                        objectives and goals on our Performance Management
                        System called Paycor. This will allow you to create
                        aligned and aspirational OKRs each quarter and track
                        your progress across teams and Avado.
                     </p>

                     <h3 className="heading heading--tertiary">Coaching</h3>
                     <p>
                        Because of our overall philosophy that we each own our
                        own careers and development, we are empowered to connect
                        with a coach (‘Pro’) for free and confidential telephone
                        or videocall-based coaching to support you at work.
                        Whatever your requirements, whether it’s dealing with a
                        difficult situation, prepping for an important meeting,
                        or succeeding as a new hire, there is a coach ready to
                        help guide you.
                     </p>
                  </div>
               </ContentContainer>

               <ContentContainer>
                  <div className="text-container--2col">
                     <h3 className="heading heading--tertiary">
                        Mentoring/Mentee-ing
                     </h3>
                     <p>
                        The benefits of mentoring/mentee-ing are endless –
                        empowerment, advice, encouragement and enlightenment to
                        name a few! We run internal and wider Blenheim Chalcot
                        mentoring/mentee schemes that are available for all
                        people. Sign up on the PX Hub by completing a
                        suitability questionnaire to refine what you’re looking
                        for from the experience.
                     </p>
                     <div className="corner-image">
                        <img src={cornerDecor} alt="" />
                     </div>
                  </div>
               </ContentContainer>

               <ContentContainer>
                  <ScrollToTopButton parentContainer={pageRef} />
               </ContentContainer>
            </main>
         </div>
      </div>
   );
};

export default Growth;
